module.exports = __webpack_public_path__ + "static/img_2211-9c7a7577917ee22301c1ddc92a0a3374.webp";